"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./TextArea.css");
require("./TextArea.css");
var icons = require("./../../../styles/att-icons.css");
var TextArea = /** @class */ (function (_super) {
    __extends(TextArea, _super);
    function TextArea(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentText: _this.props.data.input ? _this.props.data.input : '',
            disabled: props.options.disabled || false,
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.onKeyPress = _this.onKeyPress.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onClear = _this.onClear.bind(_this);
        _this.getContainerClass = _this.getContainerClass.bind(_this);
        return _this;
    }
    TextArea.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.data.input !== this.state.currentText) {
            this.setState({ currentText: newProps.data.input });
        }
        if (newProps.options.disabled !== this.state.disabled) {
            this.setState({ disabled: newProps.options.disabled });
        }
    };
    TextArea.prototype.onChange = function (event) {
        var valueStr = event.currentTarget.value;
        this.setState({ currentText: event.currentTarget.value });
        if (this.props.events && this.props.events.onChange) {
            this.props.events.onChange(event);
        }
    };
    TextArea.prototype.onKeyPress = function (event) {
        if (this.props.events && this.props.events.onKeyPress) {
            this.props.events.onKeyPress(this.state.currentText, event);
        }
    };
    TextArea.prototype.onBlur = function (event) {
        if (this.props.events && this.props.events.onBlur) {
            this.props.events.onBlur(this.state.currentText);
        }
    };
    TextArea.prototype.onFocus = function (event) {
        if (this.props.events && this.props.events.onFocus) {
            this.props.events.onFocus(this.state.currentText, event);
        }
    };
    TextArea.prototype.onClear = function (event) {
        var _this = this;
        this.setState({ currentText: '' }, function () {
            if (_this.props.events && _this.props.events.onClear) {
                _this.props.events.onClear(_this.state.currentText, event);
            }
        });
    };
    TextArea.prototype.getContainerClass = function () {
        return this.props.options.withTooltip ? [styles.textAreaTooltipContainer, styles.withTooltip].join(' ')
            : styles.textAreaTooltipContainer;
    };
    Object.defineProperty(TextArea.prototype, "ariaLabelContent", {
        get: function () {
            return "" + (this.props.options.accessibility || '');
        },
        enumerable: false,
        configurable: true
    });
    TextArea.prototype.render = function () {
        var currentText = this.state.currentText;
        return (React.createElement("div", { "data-test-id": this.props.testId, className: this.getContainerClass() },
            React.createElement("textarea", { className: [styles.textArea, this.props.options.className].join(' '), placeholder: this.props.data.placeHolder, maxLength: this.props.options.maxLength, value: this.state.currentText, onChange: this.onChange, onKeyPress: this.onKeyPress, onBlur: this.onBlur, onFocus: this.onFocus, disabled: this.state.disabled, "aria-label": this.props.options.accessibility }),
            currentText &&
                React.createElement("button", { className: [styles.closeIcon, icons.attIcon, icons.attIconXClose].join(' '), onClick: this.onClear })));
    };
    TextArea.defaultProps = {
        options: {
            className: '',
        },
    };
    return TextArea;
}(React.Component));
exports.default = TextArea;
//# sourceMappingURL=TextArea.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/TextArea/TextArea.js
// module id = 1279
// module chunks = 8